/**
 * Creates an overlay to prevent seeing the landing page during logout
 * Uses Bootstrap classes for light/dark mode compatibility
 */
export const createLogoutOverlay = (): void => {
  // Create the overlay container
  const overlay = document.createElement('div');
  overlay.id = 'logout-overlay';
  overlay.className = 'position-fixed top-0 start-0 w-100 h-100 bg-body d-flex flex-column align-items-center justify-content-center';
  overlay.style.zIndex = '9999'; // Only style we need to set inline
  
  // Create loading spinner
  const spinner = document.createElement('div');
  spinner.className = 'spinner-border text-primary';
  spinner.setAttribute('role', 'status');
  
  // Create spinner screen reader text
  const spinnerText = document.createElement('span');
  spinnerText.className = 'visually-hidden';
  spinnerText.textContent = 'Logging out...';
  
  // Create loading text
  const loadingText = document.createElement('p');
  loadingText.className = 'mt-3 text-body';
  loadingText.textContent = 'Logging out...';
  
  // Append elements
  spinner.appendChild(spinnerText);
  overlay.appendChild(spinner);
  overlay.appendChild(loadingText);
  
  // Add to document
  document.body.appendChild(overlay);
};